import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Nico Varela",
    role: "Independent web designer",
    description: "Nico Varela is an independent web designer in Lisbon crafting bold, fast and memorable websites for brands with something to say.",
    url: getOrigin(),
    ogImage: 'https://nico-varela.cdn.modulify.website/images/work/atelier-moreau.jpg',
    location: "Lisbon, Portugal",
    timeZone: 'Europe/Lisbon',
    availability: "Booking new projects from January 2027",
    availabilityShort: "Booking Jan 2027",
    socials: [
        { label: "Instagram", href: 'https://www.instagram.com/' },
        { label: "Dribbble", href: 'https://dribbble.com/' },
        { label: "LinkedIn", href: 'https://www.linkedin.com/' },
        { label: "Behance", href: 'https://www.behance.net/' }
    ]
}

export const navLinks: NavLink[] = [
    { label: "Work", href: '/#work' },
    { label: "Services", href: '/#services' },
    { label: "Process", href: '/#process' },
    { label: "About", href: '/#about' }
]
